var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropDownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M2.5 4A2 2 0 1 0 2.501.001 2 2 0 0 0 2.5 4m0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 2.5 6m0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 2.5 12"
})));
export default SvgDropDownIcon;